<template>
  <div class="csat-display-type-selector">
    <CSATEmojiInput :selected="isEmojiSelected" @update="onUpdate" />
    <CSATStarInput :selected="isStarSelected" @update="onUpdate" />
  </div>
</template>

<script>
import { CSAT_DISPLAY_TYPES } from 'shared/constants/messages';
import CSATEmojiInput from './CSATEmojiInput.vue';
import CSATStarInput from './CSATStarInput.vue';

export default {
  name: 'CSATDisplayTypeSelector',
  components: {
    CSATEmojiInput,
    CSATStarInput,
  },
  props: {
    selectedType: {
      type: String,
      default: CSAT_DISPLAY_TYPES.EMOJI,
    },
  },
  computed: {
    isEmojiSelected() {
      return this.selectedType === CSAT_DISPLAY_TYPES.EMOJI;
    },
    isStarSelected() {
      return this.selectedType === CSAT_DISPLAY_TYPES.STAR;
    },
  },
  methods: {
    onUpdate(value) {
      this.$emit('update', value);
    },
  },
};
</script>

<style scoped lang="scss">
.csat-display-type-selector {
  display: flex;
  gap: var(--space-normal);
}
</style>
